import axios from "axios";

export const submitKyc = async (
  subscriptionPlan,
verifierType,
authorizedName,
accreditationBody,
accreditationExpDate,
accreditationCertificate,
  token
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/kyc/v1/create-third-party-kyc`,
      {
        subscriptionPlan,
verifierType,
authorizedName,
accreditationBody,
accreditationExpDate,
accreditationCertificate
      },
      config
    );

    return res;
  } catch (error) {
    console.log("ERROR", error);
  }
};


export const createComment = async (
   additionalComment,
    selectedReason,
    token
   
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/admin-create-comment",
      {
         additionalComment,
    selectedReason,
   
      },
      config
    );

    return res.data; // return only data (cleaner)
  } catch (error) {
    console.error(" KYC creation error:", error);
    throw error; // rethrow if you want caller to handle it
  }
};

export const submitCommentVerification = async (token,comment,)=>{
   const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.post(
      "https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/verifier-comment",
      {
         comment,
   
      },
      config
    );

    return res.data; // return only data (cleaner)
  } catch (error) {
    console.error(" KYC creation error:", error);
    throw error; // rethrow if you want caller to handle it
  }

}
export const getUserDetails = async (token, walletAddress) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const res = await axios.get(
      `https://q9xcu8j14i.execute-api.us-east-1.amazonaws.com/dev/v1/get-device-id?walletAddress=${walletAddress}`,
      
      config
    );

    return res.data; // return only data (cleaner)
  } catch (error) {
    console.error(" KYC creation error:", error);
    throw error; // rethrow if you want caller to handle it
  }

}